export default __webpack_public_path__ + "static/media/discord.87103b7f.png";